(function () {
    var sr = window.sr = window.sr || {};
    sr.YANDEX_COUNTERID = "yaCounter37566000";
    sr.GA_NAME = null;
    sr.reachGoal = function (goalId) {
        if (goalId && window[sr.YANDEX_COUNTERID]) {
            window[sr.YANDEX_COUNTERID].reachGoal(goalId);
        }
        if (!sr.GA_NAME && window["ga"]) {
            ga(function () {
                // get ga tracker name
                var trackers = ga.getAll();
                if (trackers) {
                    sr.GA_NAME = trackers[0].get("name");
                }
            });
        }
        if (goalId && sr.GA_NAME) {
            ga(sr.GA_NAME + '.send', 'event', 'goals', goalId);
        }
    }
}());

(function () {
    // vebvisor: record field values
    $("input[type='text']").addClass("ym-record-keys");
    $("input[type='email']").addClass("ym-record-keys");
    $("input[type='tel']").addClass("ym-record-keys");
}());


// fix scroll
function hideScroll() {
    B2B.UI.Utils.fixBody();
}

function showScroll() {
    B2B.UI.Utils.unfixBody();
}

$(function () {
    // menu scroll
    $('.menu a').click(function (event) {
        event.preventDefault();
        var el = $(this).attr('href');
        $('.menu').find('a').removeClass('active');
        $(this).addClass('active');
        $('html,body').animate({
            scrollTop: $(el).offset().top - 100
        }, 1000);
        return false;
    });

    $('.js-scroll-anchor').click(function (event) {
        event.preventDefault();
        var el = $(this).attr('href');
        $('html,body').animate({
            scrollTop: $(el).offset().top - 100
        }, 1000);
        return false;
    });

    // menu fixed
    function menuFixed() {
        var start_pos = 40;
        $(window).scroll(function () {
            //if(!$(document.body).hasClass("has-b-background")) {
                if ($(window).scrollTop() >= start_pos) {
                    $('header').addClass('fixed');
                } else {
                    $('header').removeClass('fixed');
                }
            //}
        });
    }

    menuFixed();
    $(window).trigger("scroll");

    // загрузка файла в форму
    $('.js-file').change(function (event) {
        var name = this.files[0].name;
        $('.js-file-link span').text(name);
    });


    $('.js-lizing-input').priceFormat();

    $(".lazy").lazyload({
        effect: "fadeIn",
        threshold: 100
    });

    // retarget
    $('form.calc').one("change", function () {
        // retarget goal
        sr.reachGoal("rt_form_calc_interaction");
    });
    $(function () {
        // retarget goal - form interaction
        function onFormInteraction() {
            sr.reachGoal("rt_form_interaction");
            $("form input").off("keypress", onFormInteraction);
        }

        $("form input").one("keypress", onFormInteraction);
    });

    $(".js-popup_catalog_step_email form input").one("keypress", function(){
        sr.reachGoal("rt_form_step_email_interaction");
    });

    $(".btn--mail").on("click", function(){
        sr.reachGoal("rt_form_howtoget_email");
    });
    $(".btn--whatsapp").on("click", function(){
        sr.reachGoal("rt_form_howtoget_whatsapp");
    });
    $(".js-whatsapp-fixed-button").on("click", function(){
        sr.reachGoal("rt_whatsapp_fixed_click");
    });

    $('.js-pf-new-all, .js-more').click(function () {
        // retarget goal
        sr.reachGoal("rt_case_view");
    });

    // NEW POPUPS
    /*$('.js-process').click(function(){
      $('.js-popupbgnew').addClass('open');
      $('.js-popup-process').fadeIn();
      hideScroll();
    });*/
    $('.js-crytic').click(function () {
        $('.js-popupbgnew').addClass('open');
        $('.js-popup-crytic').fadeIn();
        hideScroll();
    });
    $('.js-close-new').click(function () {
        $('.js-popupbgnew').removeClass('open');
        $('.js-popup-new').fadeOut();
        showScroll();
    });
    // клик в свободной зоне
    $('.js-popupbgnew').click(function (event) {
        if ($(event.target).closest(".js-popup-new").length)
            return;
        $('.js-popupbgnew').removeClass('open');
        $('.js-popup-new').fadeOut();
        showScroll();
        event.stopPropagation();
    });


    // rt_form_open - открытие формы
    // rt_form_interaction - взаимодействие с формой
    // rt_catalog_open - открытие каталога
    // rt_form_calc_interaction - взаимодействие с калькулятором
    // rt_case_view - просматр кейсов

    // rt_form_howtoget_open - открытие формы выбора email/whatsup

    // POPUPS
    sr.popups = {
        thanks: function (title, text, isCatalog) {
            //close all
            var $popup = $('.popup');
            $popup.fadeOut(0);

            // need to re-activate catalog when click js-close
            $popup.removeAttr("data-iscatalog");
            if (isCatalog) {
                $popup.attr("data-iscatalog", "1");
            }

            $('.js-popup_thanks .js-title').text(title || "СПАСИБО!");
            $('.js-popup_thanks .js-text').text(text || "Ваше обращение уже в работе. Мы свяжемся с Вами!");

            $('.js-popup-bg').addClass('open'); //show bg
            $('.js-popup_thanks').fadeIn(200);
            $('body').css({'overflow': 'hidden'});
        },
        thanks_catalog: function (isCatalog) {
            sr.popups.thanks("Розничные\nкаталоги отправлены!", "К сожалению, вы не авторизовались и\nмы не можем предоставить вам доступ\nк оптовым каталогам.\n\nВы получите розничные каталоги по указанному email.\nПожалуйста, проверьте почту!", isCatalog);
        },
        thanks_catalog_opt: function (isCatalog) {
            sr.popups.thanks("Оптовые каталоги отправлены!", "Вы получите оптовые каталоги по указанному email.\nПожалуйста, проверьте почту!", isCatalog);
        },
        error: function (text) {
            //close all
            $('.popup').fadeOut(0);

            $('.js-popup-bg').addClass('open'); //show bg

            var msg = text || "Сервис временно недоступен, попробуйте повторить позднее.";
            $('.js-popup_error .js-text').text(msg);
            $('.js-popup_error').fadeIn(200);
            $('body').css({'overflow': 'hidden'});
        },
        catalog: function (code) {
            var $popup = $('.js-popup_catalog[data-category="' + code + '"]');
            if (!$popup.length) {
                return false;
            }

            // retarget goal
            sr.reachGoal("rt_catalog_open");

            $(".js-popup-hidden").removeClass("active");
            $(".js-popup_catalog").removeClass("active");

            $('.js-popup-bg').addClass('open'); //show bg

            $popup.find('.popup-content').fadeIn(0); // FIY: may be hidden by open js-popup-hidden
            $popup
                .addClass("active")
                .fadeIn(200);
            $('body').css({'overflow': 'hidden'});

            return true;
        },
        price: function () {
            // retarget goal
            sr.reachGoal("rt_form_open");

            $('.js-popup_catalog').fadeOut(0);

            $('.js-popup-bg').addClass('open'); //show bg
            $('.js-popup_price').fadeIn(200);
            $('body').css({'overflow': 'hidden'});
        },
        howtoget: function () {
            // retarget goal
            sr.reachGoal("rt_form_howtoget_open");

            //close all
            $('.popup').fadeOut(0);
            var d = $.Deferred();

            var $popup = $('.js-popup_howtoget');

            if(this.__resolveEmail) {
                $popup.find('.btn.btn--mail').off("click", this.__resolveEmail);
            }
            this.__resolveEmail = function(){
                // resolve only if get by email
                $popup.fadeOut(0);
                d.resolve();
            }
            $popup.find('.btn.btn--mail').on("click", this.__resolveEmail);

            $('.js-popup-bg').addClass('open'); //show bg
            $popup.fadeIn(200);
            $('body').css({'overflow': 'hidden'});

            return d;
        },
        step_email: function () {
            //close all
            $('.popup').fadeOut(0);
            var d = $.Deferred();

            var $popup = $('.js-popup_catalog_step_email');

            var $form = $popup.find('form');

            $form.off("submit");
            $form.on("submit", function(){
                if (sr.validateForm($form)) {
                    $popup.fadeOut(0);
                    d.resolve($form.find("input").val());
                }
                return false; // ignore submit
            });

            $('.js-popup-bg').addClass('open'); //show bg
            $popup.fadeIn(200);
            $('body').css({'overflow': 'hidden'});

            $form.find("[data-autofocus]").focus();

            return d;
        },
        step_phone: function () {
            //close all
            $('.popup').fadeOut(0);
            var $popup = $('.js-popup_catalog_step_phone');



            $('.js-popup-bg').addClass('open'); //show bg
            $popup.fadeIn(200);
            $('body').css({'overflow': 'hidden'});

            var $form = $popup.find('form');
            $form.find("[data-autofocus]").focus();
        },
    };

    var setupPriceForm = function (options) {
        var title = options['title'] || "Оптовый каталог";
        var dsc = options['dsc'] || '';
        var btnTxt = options['btn'] || 'Получить консультацию!';
        var theme = options['theme'];
        var isFromCalc = options['iscalc'] == "1" || false;
        var isFromLizing = options['islizing'] == "1" || false;
        var isCatalog = options['iscatalog'] == "1" || false;
        var category = options['category'] || undefined;
        var isNoEmail = options['noemail'] == "1" || false;
        var goalid = options['goalid'];

        var $pricePopup = $('.js-popup_price');
        $pricePopup.find("label.email").toggle(!isNoEmail);
        $pricePopup.find('.js-title').html(title);
        $pricePopup.find('.js-desc').html(dsc);
        $pricePopup.find('.btn').html(btnTxt);

        var $modalForm = $pricePopup.find("form");
        $modalForm.find("input").val("");
        if ($modalForm.find(".hidden").length == 0) {
            $modalForm.append('<div class="hidden"></div>');
        }
        $modalForm.find('.hidden').html("");
        $modalForm.find('.hidden').append('<input type="hidden" name="theme" value="' + theme + '">');
        if (category) {
            $modalForm.find('.hidden').append('<input type="hidden" name="category" value="' + category + '">');
        }

        $modalForm.removeAttr("data-goalid");
        if (goalid) {
            $modalForm.attr("data-goalid", goalid);
        }

        $modalForm.removeAttr("data-iscalc");
        if (isFromCalc) {
            $modalForm.attr("data-iscalc", "1");
        }

        $modalForm.removeAttr("data-islizing");
        if (isFromLizing) {
            $modalForm.attr("data-islizing", "1");
        }

        $modalForm.removeAttr("data-iscatalog");
        if (isCatalog) {
            $modalForm.attr("data-iscatalog", "1");
        }
    }

    var setupCatalogStepPhoneForm = function (options) {
        var theme = options['theme'];
        var isCatalog = options['iscatalog'] == "1" || false;
        var category = options['category'] || undefined;
        var goalid = options['goalid'];

        var $emailPopup = $('.js-popup_catalog_step_phone');
        var $modalForm = $emailPopup.find("form");
        // clear form
        $modalForm.find("input").val("");

        if ($modalForm.find(".hidden").length == 0) {
            $modalForm.append('<div class="hidden"></div>');
        }
        $modalForm.find('.hidden').html("");
        // fyi: идет в тег лида amo Оптовые каталоги
        $modalForm.find('.hidden').append('<input type="hidden" name="tag" value="Оптовые каталоги">');

        $modalForm.find('.hidden').append('<input type="hidden" name="theme" value="' + theme + '">');
        if (category) {
            $modalForm.find('.hidden').append('<input type="hidden" name="category" value="' + category + '">');
        }

        $modalForm.removeAttr("data-goalid");
        if (goalid) {
            $modalForm.attr("data-goalid", goalid);
        }

        $modalForm.removeAttr("data-iscatalog");
        if (isCatalog) {
            $modalForm.attr("data-iscatalog", "1");
        }

        var $emailFromPreviousStep = $(".js-popup_catalog_step_email input[name='email']");
        if ($emailFromPreviousStep.length) {
            $modalForm.find('.hidden').append('<input type="hidden" name="email" value="' + $emailFromPreviousStep.val() + '">');
        }
    }

    var setupCatalogStepEmailForm = function (options) {
        var title = options['title'] || "Прайс лист";
        var theme = options['theme'];
        var isCatalog = options['iscatalog'] == "1" || false;
        var category = options['category'] || undefined;
        var goalid = options['goalid'];

        var $emailPopup = $('.js-popup_catalog_step_email');
        var $modalForm = $emailPopup.find("form");
        // clear form
        $modalForm.find("input").val("");

        if ($modalForm.find(".hidden").length == 0) {
            $modalForm.append('<div class="hidden"></div>');
        }
        $modalForm.find('.hidden').html("");
        $modalForm.find('.hidden').append('<input type="hidden" name="theme" value="' + theme + '">');
        if (category) {
            $modalForm.find('.hidden').append('<input type="hidden" name="category" value="' + category + '">');
        }

        $modalForm.removeAttr("data-goalid");
        if (goalid) {
            $modalForm.attr("data-goalid", goalid);
        }

        $modalForm.removeAttr("data-iscatalog");
        if (isCatalog) {
            $modalForm.attr("data-iscatalog", "1");
        }

        $modalForm.find(".js-file-name").text(title);
    }

    var setupHowToGetForm = function (options) {
        var title = options['title'] || "Оптовый каталог";
        var isCatalog = options['iscatalog'] == "1" || false;

        // need to re-activate catalog when click js-close
        var $popup = $('.js-popup_howtoget');
        $popup.find('.js-title').html(title);
        var $modalForm = $popup.find("form");

        $modalForm.removeAttr("data-iscatalog");
        if (isCatalog) {
            $modalForm.attr("data-iscatalog", "1");
        }
    }

    var onPriceClick = function () {
        var options = $(this).data();

        if (options.category) {
            // пошаговый режим
            var step = options['step'] || undefined;
            var stepPromise = null;
            if (step === "email") {
                // спросить email
                setupCatalogStepEmailForm(options);
                stepPromise = sr.popups.step_email();
            } else {
                // сначала спросить как отправить, и если email, то спросить email
                setupHowToGetForm(options);
                stepPromise = sr.popups.howtoget().then(function () {
                    setupCatalogStepEmailForm(options);
                    return sr.popups.step_email();
                });
            }


            stepPromise.done(function (email) {
                // спросить остальные реквизиты
                // оработка отмены формы (закрытие)
                //$('.js-popup_catalog_step_phone .js-close, .js-popup-bg').off("click", handleCancel_step_phone);
                //$('.js-popup_catalog_step_phone .js-close, .js-popup-bg').on("click", handleCancel_step_phone);

                var $form = $('.js-popup_catalog_step_email form');
                sr.subscribeCatalog($form);

                setupCatalogStepPhoneForm(options);
                sr.popups.step_phone();
            });
        } else {
            setupPriceForm(options);
            sr.popups.price();
        }
    }

    /*var handleCancel_step_phone = function(event){
      if($(this).hasClass("js-popup-bg") && $(event.target).closest(".popup").length ) // ignore click if is bg and original click on inner popup
      {
          return;
      }
      // TODO: TODO TODO for BG
      if($(event.target).closest(".js-popup_catalog_step_phone").length) { // is step phone close
          // если на втором шаге реквизиты не были введены, нужно отправить форму с введенным ранее email
          var $form = $('.js-popup_catalog_step_email form');
          sr.subscribeCatalog($form);
      }

      $(this).off(event);
    }*/

    $('.js-catalog a')
        .not('[href^=#]')
        .click(function (e) {
        var cat = $(this).data("category");
        var catalogOpened = sr.popups.catalog(cat);
        // FIY: пробовать обработать как открытие формы если для категории нет popup
        if (!catalogOpened) {
            onPriceClick.call(this);
        }

        e.preventDefault();
        e.stopPropagation();
    });

    $(document).on("click", '.js-price, .js-modal', onPriceClick);

    function removeHash() {
        history.replaceState("", document.title, window.location.pathname + window.location.search);
    }

    $('.js-close').click(function (e) {

        var $popup = $(this).closest('.popup');
        var isCatalog = ($popup.find("form").length && $popup.find("form").attr('data-iscatalog') == "1")
            || $popup.attr('data-iscatalog') == "1";

        if($popup.hasClass("js-popup_catalog_step_phone")){
            sr.popups.thanks_catalog(isCatalog); // popup thanks розничный каталог
        }
        else if (isCatalog
            && $('.js-popup_catalog.active').length
            && !$('.js-popup_catalog.active').is($popup)) {
            $('.popup').fadeOut(0);
            $('.js-popup_catalog.active').fadeIn(200);
        } else {
            $('.js-popup-bg').removeClass('open');// hide bg

            $('.popup, .js-popup').fadeOut(0);
            $('.js-popup_catalog.active').removeClass('active');
            $('body').css({'overflow': 'visible'});

            removeHash();
        }
        e.stopPropagation();
    });
    $('.js-popup-bg').click(function (event) {
        if ($(event.target).closest(".popup").length) // is popup click
            return;

        var isStepPhonePopup = $('.popup.js-popup_catalog_step_phone').is(':visible');

        if ($('.js-popup_price').is(':visible') && $('.js-popup_price').find("form").attr('data-iscatalog') == "1") {
            $('.js-popup_price').fadeOut(0);
            $('.js-popup_catalog.active').fadeIn(200);
        } else {

            $('.js-popup-bg').removeClass('open');// hide bg
            $('.popup, .js-popup').fadeOut(0);
            $('.js-popup_catalog.active').removeClass('active');
            $('body').css({'overflow': 'visible'});

            removeHash();
        }

        if(isStepPhonePopup){
            sr.popups.thanks_catalog(); // popup thanks розничный каталог
        }

        event.stopPropagation();
    });

    $('.js-pop-catalog-item_has-data').on("click", function () {
        var code = $(this).data("subcategory");
        $('.js-popup-hidden').removeClass('active');
        if (code) {
            $(this).closest('.js-popup-content-wrap').find('.popup-content').fadeOut(0); // hide popup_content
            var $content = $('.js-popup-hidden[data-subcategory="' + code + '"]');
            $content.find('img.js-cat-lazy').lazyload({
                event: "custom_start",
                effect: "fadeIn",
                skip_invisible: false,
                container: $content.find(".popup-content-hidden-content")
            });
            $content.find('img.js-cat-lazy').trigger("custom_start"); // fix load
            $content
                .addClass('active');
        }
    });
    $('.js-popup-back').click(function () {
        $(".js-popup-hidden").removeClass("active");
        $(this).closest('.js-popup-content-wrap').find('.popup-content').fadeIn(200); //show popup_content
    });

    // project-photos
    $('.js-project-photos a').click(function (e) {
        if (!$(this).hasClass('js-first')) {
            e.preventDefault();
            var img = $(this).attr('href');
            $(this).closest('.js-project-photos').find('.js-first').attr({'href': img}).find('img').attr({'src': img})
            return false;
        }
    });

    // update date and time
    function updateDateTime() {
        var date = new Date();
        var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
        var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
        var time = hours + '<span class="blink">:</span>' + minutes;
        var $jsTime = $(".js-time");
        if ($jsTime.length) {
            $jsTime.html(time);
        }
        var $jsDate = $(".js-date");
        if ($jsDate.length) {
            $jsDate.html(date.toLocaleDateString());
        }
    }

    updateDateTime();
    window.setInterval(updateDateTime, 1000 * 30);

});

(function () {
    var sr = window.sr = window.sr || {};
    /* validator */
    var validator = {
        required: function ($i) {
            if ($i.val() == '' || $i.val() == $i.attr('placeholder')) {
                fieldError.call($i, lang.requiredError);

                return false;
            }
            return true;
        },
        email: function ($i) {

            if ($i.val() == '') return true;

            var r = new RegExp(".+@.+\..+", "i");
            if (!r.test($i.val())) {
                fieldError.call($i, lang.emailError);
                return false;
            }
            return true;
        },
        phone: function ($i) {
            var r = new RegExp("([1-9])", "i");
            if (!r.test($i.val())) {
                fieldError.call($i, lang.phoneError);
                return false;
            }
            return true;
        }
    }

    var fieldError = function (message) {
        if (!$(this).parent().hasClass('feild_wrapper')) {
            $(this).wrap('<div class="feild_wrapper"></div>');
            $(this).parent().append('<span class="error_label"></span>');
        }
        $(this).parent().addClass('wrong');
        $(this).siblings('.error_label').text(message);
        return false;
    }

    var lang = {
        success: 'Ваша заявка успешно отправлена',
        error: 'Произошла ошибка, попробуйте еще раз',
        name: 'Имя',
        phone: 'Телефон',
        email: 'Email',
        programs: 'Программы',
        requiredError: 'Заполните это поле!',
        emailError: 'Поле Email должно содержать корректный адрес',
        phoneError: 'Укажите корректный номер телефона'
    };

    sr.validateForm = function ($form) {
        var rules = Object();

        var inputs = $form.find('input, select').add('textarea', $form.get(0));

        var validate = true;
        inputs.each(function () {
            var r = $(this).data('rules');
            if (r && r.length != 0) {
                rules[$(this).attr('name')] = r;
                r = r.split(',');
                for (var i = 0; i < r.length; i++) {
                    var rule = r[i];
                    if (validator[rule]) {
                        if (!validator[rule]($(this))) {
                            validate = false;
                        }
                    }
                }
            }
        });
        return validate;
    }

    sr.subscribeCatalog = function ($form) {
        var d = $.Deferred();

        var data = $form.serializeObject();

        $.ajax({
            url: '/mail/subscribe.php',
            data: $.extend({}, data, {url: location.protocol + '//' + location.host + location.pathname}),
            type: 'post',
            dataType: 'JSON',
            cache: false,
            xhrFields: {
                withCredentials: true
            },
            success: function (data) {
                d.resolve(data);
            },
            error: function () {
                d.reject(data);
            }
        });

        d.resolve();

        return d;
    }

    sr.submitForm = function ($form) {
        var d = $.Deferred();
        var goalId = $form.attr("data-goalid");

        var data = $form.serializeObject();

        var isFromCalc = $form.attr("data-iscalc") == "1";
        if (isFromCalc) {
            data = $.extend({iscalc: 1}, data, $("form.calc").serializeObject());
        }

        var isFromLizing = $form.attr("data-islizing") == "1";
        if (isFromLizing) {
            data = $.extend({}, data, $("form.js-form-lizing").serializeObject());
        }

        $.ajax({
            url: '/mail/mail.php',
            data: $.extend({}, data, {url: location.protocol + '//' + location.host + location.pathname}),
            type: 'post',
            dataType: 'JSON',
            cache: false,
            xhrFields: {
                withCredentials: true
            },
            success: function (response) {
                if (goalId) {
                    sr.reachGoal(goalId);
                }
                d.resolve(response);
            },
            error: function (xhr, status, errorThrown) {
                d.reject(xhr.responseText);
            }
        });

        return d;
    }

    $(function () {
        $(document).on('click', '.go', function (e) {
            //e.stopPropagation();
            e.preventDefault();

            var $thisBtn = $(this);

            try {
                var $form = $(this).closest('form');

                if (!sr.validateForm($form)) return;

                $thisBtn.addClass('btn-disabled');

                sr.subscribeCatalog($form);

                sr.submitForm($form).done(function(){
                    if($form.closest(".js-popup_catalog_step_phone").length){
                        sr.popups.thanks_catalog_opt();
                    }
                    else {
                        sr.popups.thanks();
                    }
                    $thisBtn.addClass('go').removeClass('btn-disabled');
                })
                .fail(function(error){
                    //var text = error;
                    sr.popups.error();
                    $thisBtn.addClass('go').removeClass('btn-disabled');
                });
            } catch (err) {
                var text = err.stack;
                sr.popups.error(text);
                $thisBtn.addClass('go').removeClass('btn-disabled');
            }

            return false;
        });
    });
})();